/**
 * @class passwordActionCreators.
 *
 */
import * as ajax from './ajax';
import passwordConstants from '../constants/passwordConstants';
import loginActionCreators from './loginActionCreators';
import notificationActionCreators from './notificationActionCreators';
const checkPasswordRules = password => ({
  type: passwordConstants.PASSWORD_RULES_CHECK,
  password
});
const resetPasswordRules = () => ({
  type: passwordConstants.PASSWORD_RULES_RESET
});
const serverSavePassword = (id, password, customer, username, mfaPin) => async dispatch => {
  try {
    await ajax.put(`/password/${id}`, JSON.stringify({
      password
    }));
    const user = {
      user_id: id,
      password
    };
    dispatch(notificationActionCreators.success({
      message: 'Password reset successfully!'
    }));
    dispatch(loginActionCreators.passwordSaveSuccess(user));
    return dispatch(loginActionCreators.serverLogin(customer, username, password, mfaPin));
  } catch (e) {
    const error = ajax.getError(e);
    return dispatch(notificationActionCreators.error({
      message: error.error_msg
    }));
  }
};
const passwordActionsCreators = {
  checkPasswordRules,
  resetPasswordRules,
  serverSavePassword
};
export default passwordActionsCreators;